import React, { useState, useEffect, useRef } from 'react';
import './Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import FormularioManutencao from '../Formulario/FormularioManutencao';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';
import { ehPrincipal, textoResponsavelCard } from '../utils/responsavelPrincipal';
import PopupHorasReais, { salvarHorasReais } from '../components/PopupHorasReais';
import PopupNovaPessoa from '../components/PopupNovaPessoa';

// Helper: listens for MobileFooter generic + event
function MobileAddListener({ onOpen }) {
  useEffect(() => {
    window.addEventListener('open-mobile-add-popup', onOpen);
    return () => window.removeEventListener('open-mobile-add-popup', onOpen);
  }, [onOpen]);
  return null;
}
 
function ManutencaoDropdown() {
    // Component state
    const [manutencoes, setManutencoes] = useState([]);
    const [novaManutencaoAberta, setNovaManutencaoAberta] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dadosEdicao, setDadosEdicao] = useState(null);
    const [modoEdicao, setModoEdicao] = useState(false);
    const [responsaveis, setResponsaveis] = useState([]);
    // { manutencaoId: [responsáveis] }
    const [responsaveisPorManutencao, setResponsaveisPorManutencao] = useState({});
    // Concluir manutenção: pop-up das horas reais (dados do formulário esperando as horas) e as horas informadas
    const [conclusaoPendente, setConclusaoPendente] = useState(null);
    const horasReaisConclusaoRef = useRef(null);
    // "Adicionar nova pessoa" no pop-up de adicionar responsável
    const [novaPessoaAberta, setNovaPessoaAberta] = useState(false);
    const [responsaveisSelecionados, setResponsaveisSelecionados] = useState([]);
    const [filtroResp, setFiltroResp] = useState('');

    const [producoes, setProducoes] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [pessoas, setPessoas] = useState([]);

    const [filtro, setFiltro] = useState('');
    const [tipoFiltro, setTipoFiltro] = useState('idManutencao');
    const [dropdownAberto, setDropdownAberto] = useState(false);

    // Opções para o seletor de filtro (usado no campo "Filtrar por")
    const opcoesFiltro = [
        { value: 'idManutencao', label: 'ID Manutenção' },
        { value: 'idProducao', label: 'ID Projeto' },
        { value: 'idCliente', label: 'ID Cliente' },
        { value: 'responsavel', label: 'Responsável' },
        { value: 'data', label: 'Data' }
    ];
    const [calendarioAberto, setCalendarioAberto] = useState(false);
    const [mesAtual, setMesAtual] = useState(new Date());
    const [manutencoesPorData, setManutencoesPorData] = useState({});
    const [datasSelecionadas, setDatasSelecionadas] = useState(null);
    const [mostrarManutencoesoDia, setMostrarManutencoesoDia] = useState(false);
    const [manutencoesDoDia, setManutencoesDoDia] = useState([]);
    const [dataPreSelecionadaManutencao, setDataPreSelecionadaManutencao] = useState('');

    const [selecionarProducaoAberto, setSelecionarProducaoAberto] = useState(false);
    const [producaoSelecionada, setProducaoSelecionada] = useState(null);
    const [producoesFiltradas, setProducoesFiltradas] = useState([]);
    // Garantia e manutenção só para projeto finalizado e dentro do prazo de garantia (conta da aprovação do cliente)
    const producoesFinalizadas = producoesFiltradas.filter(p => /conclu|finaliz/i.test(p.Status || p.status || p.StatusNome || p.statusNome || '') && p.dentroDaGarantia !== false);
    const [filtroProducao, setFiltroProducao] = useState('');
    const [tipoFiltroProducao, setTipoFiltroProducao] = useState('todos');
    const [loadingProducoes, setLoadingProducoes] = useState(false);

    const [responsaveisManutencao, setResponsaveisManutencao] = useState([]);
    const [adicionarRespAberto, setAdicionarRespAberto] = useState(false);
    const [novoResponsavel, setNovoResponsavel] = useState({ responsavelId: '', horasPrevistas: '', horasReais: '' });

    // Ref para FormularioMateriaPrima
    const refFormularioMateriaPrima = useRef(null);

    // Base URLs used in API calls
    const BASE_URLS = [BASE_URL];

    const BASE_URLS_PRODUCAO = [
        `${BASE_URL}/Producoes`,
        `${BASE_URL}/Producoes`,
        '/api/Producoes'
    ];

    const BASE_URLS_CLIENTE = [
        `${BASE_URL}/Clientes`,
        `${BASE_URL}/Clientes`,
        '/api/Clientes'
    ];

    const BASE_URLS_PESSOAS = [
        `${BASE_URL}/Pessoas`,
        `${BASE_URL}/Pessoas`,
        '/api/Pessoas'
    ];

    // BASE_URLS_HORAS removido - horas agora são incluídas no modelo Responsaveis

    const BASE_URLS_RESP = [
        `${BASE_URL}/Responsaveis`,
        `${BASE_URL}/Responsaveis`,
        '/api/Responsaveis'
    ];

    // Função para fazer chamadas à API com fallback
    const apiCall = async (urls, endpoint = '', method = 'GET', data = null) => {
        let lastError;
        for (const baseUrl of urls) {
            try {
                const url = endpoint ? `${baseUrl}/${endpoint}` : baseUrl;
                console.log(`Tentando ${method} ${url}`);
                const config = {
                    method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
                const token = getAuthToken();
                if (token) config.headers['Authorization'] = `Bearer ${token}`;
                if (data && method !== 'GET') {
                    config.body = JSON.stringify(data);
                }
                const response = await fetch(url, config);
                if (!response.ok) {
                    throw new Error(`Erro ${response.status}: ${response.statusText}`);
                }
                
                // Verificar se há conteúdo na resposta
                const contentLength = response.headers.get('content-length');
                if (contentLength === '0' || response.status === 204) {
                    console.log(`✅ Sucesso ${method} ${url} (sem conteúdo)`);
                    return null;
                }
                
                const result = await response.json();
                console.log(`✅ Sucesso ${method} ${url}`);
                return result;
            } catch (error) {
                console.log(`❌ Erro ${method} ${baseUrl}${endpoint ? '/' + endpoint : ''}:`, error.message);
                lastError = error;
                continue;
            }
        }
        throw lastError;
    };

    // Carregar dados ao montar o componente
    useEffect(() => {
        fetchManutencoes();
        fetchProducoes();
        fetchClientes();
        fetchPessoas();
        fetchResponsaveis();
    }, []);

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('manutencao-popup-state', {
            detail: { formularioAberto: novaManutencaoAberta }
        }));
    }, [novaManutencaoAberta]);

    useEffect(() => {
        const handler = () => {
            setNovaManutencaoAberta(false);
            setModoEdicao(false);
            setDadosEdicao(null);
            setDropdownAberto(false);
            setCalendarioAberto(false);
            setMostrarManutencoesoDia(false);
            setSelecionarProducaoAberto(false);
            setAdicionarRespAberto(false);
            setProducaoSelecionada(null);
            setDataPreSelecionadaManutencao('');
        };
        window.addEventListener('manutencao-fechar-todos-popups', handler);
        return () => window.removeEventListener('manutencao-fechar-todos-popups', handler);
    }, []);

    const fetchManutencoes = async () => {
        try {
            setLoading(true);
            console.log('🔧 Carregando manutenções...');
            const data = await apiCall(BASE_URLS);
            setManutencoes(Array.isArray(data) ? data : []);
            console.log('✅ Manutenções carregadas:', data);
        } catch (error) {
            console.error('❌ Erro ao carregar manutenções:', error);
            setManutencoes([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchProducoes = async () => {
        try {
            const data = await apiCall(BASE_URLS_PRODUCAO);
            const arr = Array.isArray(data) ? data : [];
            setProducoes(arr);
            setProducoesFiltradas(arr);
        } catch (error) {
            console.error('❌ Erro ao carregar projetos:', error);
            setProducoes([]);
            setProducoesFiltradas([]);
        }
    };

    const fetchClientes = async () => {
        try {
            const data = await apiCall(BASE_URLS_CLIENTE);
            setClientes(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('❌ Erro ao carregar clientes:', error);
            setClientes([]);
        }
    };

    const fetchPessoas = async () => {
        try {
            const data = await apiCall(BASE_URLS_PESSOAS);
            setPessoas(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('❌ Erro ao carregar pessoas:', error);
            setPessoas([]);
        }
    };

    const fetchResponsaveis = async () => {
        try {
            const data = await apiCall(BASE_URLS_RESP);
            const arr = Array.isArray(data) ? data : [];
            // Responsáveis de cada manutenção (para o card: o principal, ou "N responsáveis")
            const porManutencao = {};
            arr.forEach(r => {
                const mid = r.manutencaoId ?? r.ManutencaoId;
                if (mid) (porManutencao[mid] = porManutencao[mid] || []).push(r);
            });
            setResponsaveisPorManutencao(porManutencao);
            // Filtra apenas responsáveis "base" sem vínculos
            const disponiveis = arr.filter(r =>
                (!r.tarefasId || r.tarefasId === 0) &&
                (!r.producaoId || r.producaoId === 0) &&
                (!r.montagemId || r.montagemId === 0) &&
                (!r.entregaId || r.entregaId === 0) &&
                (!r.manutencaoId || r.manutencaoId === 0) &&
                (!r.garantiaId || r.garantiaId === 0)
            );
            setResponsaveis(disponiveis);
        } catch (error) {
            console.error('❌ Erro ao carregar responsáveis:', error);
            setResponsaveis([]);
        }
    };

    // Buscar manutenção por ID para edição
    const fetchManutencaoPorId = async (id) => {
        horasReaisConclusaoRef.current = null;
        try {
            console.log('🔍 Buscando manutenção por ID:', id);
            const manutencao = await apiCall(BASE_URLS, `${id}`);
            setDadosEdicao(manutencao);
            setModoEdicao(true);
            setNovaManutencaoAberta(true);
            
            // Buscar responsáveis vinculados
            await fetchResponsaveisPorManutencao(id);
            // Force child (FormularioMateriaPrima) to load allocated materials for this manutencao
            const manutId = manutencao.id || manutencao.Id || id;
            if (manutId && refFormularioMateriaPrima.current && typeof refFormularioMateriaPrima.current.carregarMateriasAlocadas === 'function') {
                try { await refFormularioMateriaPrima.current.carregarMateriasAlocadas(manutId); } catch (err) { console.warn('Aviso: falha ao carregar matérias-primas (manutenção):', err); }
            }
            
            console.log('✅ Manutenção encontrada:', manutencao);
        } catch (error) {
            console.error('❌ Erro ao buscar manutenção:', error);
            alert('Erro ao carregar dados da manutenção para edição.');
        }
    };

    // Buscar responsáveis por manutenção
    const fetchResponsaveisPorManutencao = async (manutencaoId) => {
        try {
            const data = await apiCall(BASE_URLS_RESP);
            const arr = Array.isArray(data) ? data : [];
            const responsaveisVinculados = arr.filter(r => 
                (r.manutencaoId || r.ManutencaoId) == manutencaoId
            );
            // Fetch pessoas directly to guarantee we have the latest list for mapping
            let pessoasArr = pessoas;
            try {
                const pessoasData = await apiCall(BASE_URLS_PESSOAS);
                pessoasArr = Array.isArray(pessoasData) ? pessoasData : pessoasArr || [];
            } catch (errP) {
                // fallback to whatever is in state
                pessoasArr = pessoasArr || [];
                console.warn('Falha ao buscar pessoas para mapear responsáveis (usando cache):', errP);
            }

            // Resolver nome da pessoa e possíveis horas via lista de pessoas carregada
            const mapped = [];
            for (const r of responsaveisVinculados) {
                const pessoasId = r.pessoasId || r.PessoasId || r.pessoasid || r.Pessoasid || r.PessoasId || null;
                const nestedPessoa = r.pessoa || r.Pessoa || r.Pessoas || r.PessoasObj || null;

                let pessoaObj = nestedPessoa || (pessoasArr.find(p => (p.id || p.Id) == pessoasId) || null);

                // If not found in list, try fetching single pessoa by id (some APIs support GET /api/Pessoas/{id})
                if (!pessoaObj && pessoasId) {
                    try {
                        const single = await apiCall(BASE_URLS_PESSOAS, `${pessoasId}`);
                        pessoaObj = single || pessoaObj;
                    } catch (errSingle) {
                        // ignore, we'll fallback to empty
                    }
                }

                const nome = r.nome || r.Nome || (pessoaObj && (pessoaObj.nome || pessoaObj.Nome)) || (nestedPessoa && (nestedPessoa.nome || nestedPessoa.Nome)) || null;
                const custo = r.custoHora || r.CustoHora || (pessoaObj && (pessoaObj.custoHora || pessoaObj.CustoHora)) || null;
                const horasPrev = r.horasPrevistas || r.HorasPrevistas || r.horasPrev || r.HorasPrev || null;
                const horasReal = r.horasReais || r.HorasReais || r.horasReal || r.HorasReal || null;

                mapped.push({ ...r, nome, custoHora: custo, horasPrevistas: horasPrev, horasReais: horasReal });
            }

            console.log('Responsáveis vinculados (raw):', responsaveisVinculados);
            console.log('Responsáveis vinculados (mapped):', mapped);

            setResponsaveisManutencao(mapped);
            return mapped;
        } catch (error) {
            console.error('❌ Erro ao buscar responsáveis da manutenção:', error);
            setResponsaveisManutencao([]);
            return [];
        }
    };

    // Adicionar responsável à manutenção
    const handleAdicionarResponsavel = async () => {
        if (!novoResponsavel.responsavelId) {
            alert('Selecione um responsável');
            return;
        }

        if (!dadosEdicao || !dadosEdicao.id) {
            alert('É necessário salvar a manutenção antes de adicionar responsáveis');
            return;
        }

        try {
            // Criar vínculo usando PessoasId (não clonar por nome)
            const pessoaId = novoResponsavel.responsavelId;
            const horasPrevistas = novoResponsavel.horasPrevistas ? parseFloat(novoResponsavel.horasPrevistas) : 0;

            // Horas agora são incluídas no payload do Responsaveis (novo modelo)
            const payloadResponsavel = {
                Id: 0,
                PessoasId: parseInt(pessoaId),
                ManutencaoId: parseInt(dadosEdicao.id),
                ProducaoId: dadosEdicao.producoesId ? parseInt(dadosEdicao.producoesId) : null,
                id_cliente: dadosEdicao.id_cliente ? parseInt(dadosEdicao.id_cliente) : 0,
                // Ao adicionar, só horas previstas; as reais são lançadas ao concluir a manutenção
                HorasPrevistas: horasPrevistas
            };

            const respResult = await apiCall(BASE_URLS_RESP, '', 'POST', payloadResponsavel);

            alert('Responsável adicionado com sucesso!');
            setAdicionarRespAberto(false);
            setNovoResponsavel({ responsavelId: '', horasPrevistas: '', horasReais: '' });

            // Recarregar responsáveis vinculados
            await fetchResponsaveisPorManutencao(dadosEdicao.id);
            await fetchResponsaveis();
        } catch (error) {
            alert('Erro ao adicionar responsável: ' + error.message);
            console.error(error);
        }
    };

    // Remover responsável da manutenção
    // Marca/desmarca o responsável principal da manutenção (só um; com um responsável só, ele é o principal)
    const handleDefinirPrincipal = async (responsavel) => {
        try {
            const id = responsavel.id || responsavel.responsaveisId || responsavel.ResponsaveisId;
            await apiCall(BASE_URLS_RESP, `${id}/principal`, 'PUT', { principal: !ehPrincipal(responsavel) });
            if (dadosEdicao && dadosEdicao.id) await fetchResponsaveisPorManutencao(dadosEdicao.id);
            await fetchResponsaveis();
        } catch (error) {
            alert('Erro ao definir o responsável principal: ' + error.message);
        }
    };

    const handleRemoverResponsavel = async (responsavel) => {
        if (!window.confirm(`Deseja remover ${responsavel.nome || responsavel.Nome}?`)) {
            return;
        }

        try {
            const id = responsavel.id || responsavel.responsaveisId || responsavel.ResponsaveisId;
            await apiCall(BASE_URLS_RESP, `${id}`, 'DELETE');
            alert('Responsável removido com sucesso!');
            
            // Recarregar responsáveis
            if (dadosEdicao && dadosEdicao.id) {
                await fetchResponsaveisPorManutencao(dadosEdicao.id);
            }
            await fetchResponsaveis();
        } catch (error) {
            alert('Erro ao remover responsável: ' + error.message);
            console.error(error);
        }
    };

    // Filtrar produções com base no filtro e tipo
    useEffect(() => {
        if (!filtroProducao) {
            setProducoesFiltradas(producoes);
            return;
        }

        const val = filtroProducao.toLowerCase();
        const filtered = producoes.filter(p => {
            if (tipoFiltroProducao === 'todos') {
                const id = (p.producaoId || p.ProducaoId || '').toString().toLowerCase();
                const contratoId = (p.contratosId || p.ContratosId || '').toString().toLowerCase();
                const oportunidadeId = (p.oportunidadeId || p.OportunidadeId || '').toString().toLowerCase();
                const titulo = (p.oportunidadeTitulo || p.OportunidadeTitulo || '').toLowerCase();
                const clienteId = (p.clienteId || p.ClienteId || '').toString().toLowerCase();
                const vendaId = (p.vendaId || p.VendaId || '').toString().toLowerCase();
                return id.includes(val) || contratoId.includes(val) || oportunidadeId.includes(val) || 
                       titulo.includes(val) || clienteId.includes(val) || vendaId.includes(val);
            } else if (tipoFiltroProducao === 'producaoId') {
                return (p.producaoId || p.ProducaoId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'contratoId') {
                return (p.contratosId || p.ContratosId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'oportunidadeId') {
                return (p.oportunidadeId || p.OportunidadeId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'titulo') {
                return (p.oportunidadeTitulo || p.OportunidadeTitulo || '').toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'clienteId') {
                return (p.clienteId || p.ClienteId || '').toString().toLowerCase().includes(val);
            } else if (tipoFiltroProducao === 'vendaId') {
                return (p.vendaId || p.VendaId || '').toString().toLowerCase().includes(val);
            }
            return true;
        });
        setProducoesFiltradas(filtered);
    }, [filtroProducao, tipoFiltroProducao, producoes]);

    // Função para selecionar produção e abrir formulário
    const selecionarProducao = (producao) => {
        setProducaoSelecionada(producao);
        setModoEdicao(false);
        setDadosEdicao(null);
        setSelecionarProducaoAberto(false);
        setNovaManutencaoAberta(true);
    };

    // Filtrar manutenções
    const manutencoesFiltradas = manutencoes.filter(manutencao => {
        if (!filtro) return true;

        const valorFiltro = filtro.toLowerCase();

        switch (tipoFiltro) {
            case 'idManutencao':
                return String(manutencao.id || manutencao.Id).toLowerCase().includes(valorFiltro);
            case 'idProducao':
                return String(manutencao.producoesId || manutencao.ProducoesId || '').toLowerCase().includes(valorFiltro);
            case 'idCliente':
                return String(manutencao.id_cliente || manutencao.Id_cliente || '').toLowerCase().includes(valorFiltro);
            case 'responsavel':
                return (manutencao.responsavel || manutencao.Responsavel || '').toLowerCase().includes(valorFiltro);
            case 'data':
                return (manutencao.dataExecucao || manutencao.DataExecucao || '').toLowerCase().includes(valorFiltro);
            default:
                return true;
        }
    });

    // Obter nome da produção
    const getNomeProducao = (producaoId) => {
        const producao = producoes.find(p => (p.producaoId || p.ProducaoId) === producaoId);
        return producao ? (producao.titulo || producao.Titulo || `Projeto #${producaoId}`) : `ID: ${producaoId}`;
    };

    // Obter nome do cliente
    const getNomeCliente = (clienteId) => {
        const cliente = clientes.find(c => (c.id || c.Id) === clienteId);
        return cliente ? (cliente.nome || cliente.Nome) : `ID: ${clienteId}`;
    };

    // Formulário para criar/editar manutenção
    const handleSubmitManutencao = async (dadosFormulario) => {
        // Diminuição de matéria-prima sem dizer o destino do material (perdido / volta ao estoque): não salva
        if (refFormularioMateriaPrima.current?.validarAlteracoes && !refFormularioMateriaPrima.current.validarAlteracoes()) return;
        try {
            setLoading(true);
            
            if (modoEdicao && dadosEdicao) {
                // Editar manutenção existente (sem responsáveis no form de edição)
                const manutencaoId = dadosEdicao.id || dadosEdicao.Id;
                // Concluindo a manutenção: as horas reais de cada responsável são informadas agora (no pop-up)
                const concluindo = /conclu/i.test(dadosFormulario.status || '') && !/conclu/i.test(dadosEdicao.status || dadosEdicao.Status || '');
                if (concluindo && responsaveisManutencao.length > 0 && horasReaisConclusaoRef.current === null) {
                    setConclusaoPendente(dadosFormulario);
                    return;
                }
                if (concluindo && horasReaisConclusaoRef.current) {
                    await salvarHorasReais(horasReaisConclusaoRef.current);
                    horasReaisConclusaoRef.current = null;
                }
                const manutencaoData = {
                    Id: parseInt(manutencaoId),
                    ProducoesId: dadosFormulario.producoesId ? parseInt(dadosFormulario.producoesId) : null,
                    Id_cliente: dadosFormulario.id_cliente ? parseInt(dadosFormulario.id_cliente) : null,
                    Descricao: dadosFormulario.descricao || '',
                    DataExecucao: dadosFormulario.dataExecucao || null,
                    Custo: dadosFormulario.custo ? parseFloat(dadosFormulario.custo) : null,
                    Responsavel: dadosFormulario.responsavel || '',
                    PessoaId: dadosFormulario.pessoaId ? parseInt(dadosFormulario.pessoaId) : null,
                    Status: dadosFormulario.status || 'Pendente'
                };
                
                console.log('Editando manutenção:', manutencaoId, manutencaoData);
                await apiCall(BASE_URLS, `${manutencaoId}`, 'PUT', manutencaoData);
                
                // POST de matérias-primas alocadas (modo edição também aloca)
                if (refFormularioMateriaPrima.current) {
                    try {
                        const resultAloc = await refFormularioMateriaPrima.current.alocarMateriaisParaTarefa(manutencaoId);
                        console.log('✅ Matérias-primas alocadas para manutenção (edição):', resultAloc);
                    } catch (errMat) {
                        console.warn('Aviso: Erro ao alocar matérias-primas (manutenção foi editada):', errMat);
                        // Não bloqueia a edição se matérias-primas falharem
                    }
                }
                
                alert('Manutenção editada com sucesso!');
            } else {
                // Criar nova manutenção
                const manutencaoData = {
                    ProducoesId: dadosFormulario.producoesId,
                    Id_cliente: dadosFormulario.id_cliente,
                    Descricao: dadosFormulario.descricao || '',
                    DataExecucao: dadosFormulario.dataExecucao || null,
                    Custo: dadosFormulario.custo,
                    Responsavel: dadosFormulario.responsavel || '',
                    PessoaId: dadosFormulario.pessoaId,
                    Status: dadosFormulario.status || 'Pendente'
                };
                
                console.log('Criando manutenção:', manutencaoData);
                const criada = await apiCall(BASE_URLS, '', 'POST', manutencaoData);
                const manutencaoId = criada?.id || criada?.Id;

                // POST de responsáveis vinculados à manutenção usando pessoasId, producaoId e manutencaoId
                if (manutencaoId && dadosFormulario.responsaveis && dadosFormulario.responsaveis.length > 0) {
                    for (let i = 0; i < dadosFormulario.responsaveis.length; i++) {
                        const pessoaId = dadosFormulario.responsaveis[i];
                        if (pessoaId && pessoaId.toString().trim()) {
                            try {
                                const payloadResponsavel = {
                                    Id: 0,
                                    PessoasId: parseInt(pessoaId),
                                    ProducaoId: dadosFormulario.producoesId ? parseInt(dadosFormulario.producoesId) : null,
                                    ManutencaoId: parseInt(manutencaoId)
                                };
                                console.log('Criando responsável vinculado à manutenção:', payloadResponsavel);
                                await apiCall(BASE_URLS_RESP, '', 'POST', payloadResponsavel);
                            } catch (errResp) {
                                console.error('Erro ao vincular responsável:', errResp);
                                // Continua mesmo se falhar para um responsável
                            }
                        }
                    }
                }

                // 3. POST de matérias-primas alocadas para a manutenção
                if (refFormularioMateriaPrima.current) {
                    try {
                        const resultAloc = await refFormularioMateriaPrima.current.alocarMateriaisParaTarefa(manutencaoId);
                        console.log('✅ Matérias-primas alocadas para manutenção:', resultAloc);
                    } catch (errMat) {
                        console.error('Aviso: Erro ao alocar matérias-primas (manutenção foi criada):', errMat);
                        // Não bloqueia a criação da manutenção se matérias-primas falharem
                    }
                }

                alert(`Manutenção criada com sucesso!${dadosFormulario.responsaveis?.length ? `\n\n${dadosFormulario.responsaveis.length} responsável(is) vinculado(s).` : ''}`);
            }

            // Resetar formulário e recarregar lista
            setNovaManutencaoAberta(false);
            setModoEdicao(false);
            setDadosEdicao(null);
            setProducaoSelecionada(null);
            await fetchManutencoes();
            await fetchResponsaveis();
            
        } catch (error) {
            console.error('Erro ao salvar manutenção:', error);
            alert('Erro ao salvar manutenção: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Funções do Calendário
    const abrirCalendario = () => {
        processarManutencoesPorData();
        setCalendarioAberto(true);
    };

    const processarManutencoesPorData = () => {
        const manutencoesPorDataMap = {};
        
        manutencoes.forEach(manutencao => {
            const dataExecucao = manutencao.DataExecucao || manutencao.dataExecucao;
            if (!dataExecucao) return;

            const data = dataExecucao.split('T')[0]; // YYYY-MM-DD
            
            if (!manutencoesPorDataMap[data]) {
                manutencoesPorDataMap[data] = [];
            }
            
            manutencoesPorDataMap[data].push(manutencao);
        });
        
        setManutencoesPorData(manutencoesPorDataMap);
    };

    const selecionarDia = (data) => {
        const dataStr = `${data.getFullYear()}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${data.getDate().toString().padStart(2, '0')}`;
        const manutencoesDoDiaClicado = manutencoesPorData[dataStr];
        
        if (manutencoesDoDiaClicado && manutencoesDoDiaClicado.length > 0) {
            setManutencoesDoDia(manutencoesDoDiaClicado);
            setDatasSelecionadas(data);
            setMostrarManutencoesoDia(true);
        } else {
            // Dia vazio: inicia o fluxo de criação de nova manutenção com a data já preenchida
            abrirNovaManutencaoParaData(dataStr);
        }
    };

    // Inicia o fluxo de "Adicionar Manutenção" (seleção de produção) com uma data pré-definida
    const abrirNovaManutencaoParaData = (dataStr) => {
        setDataPreSelecionadaManutencao(dataStr);
        setModoEdicao(false);
        setDadosEdicao(null);
        setMostrarManutencoesoDia(false);
        setCalendarioAberto(false);
        setSelecionarProducaoAberto(true);
    };

    const editarManutencaoDoDia = async (manutencao) => {
        const manutencaoId = manutencao.Id || manutencao.id;
        await fetchManutencaoPorId(manutencaoId);
        setModoEdicao(true);
        setMostrarManutencoesoDia(false);
        setCalendarioAberto(false);
        setNovaManutencaoAberta(true);
    };

    const renderCalendario = () => {
        const ano = mesAtual.getFullYear();
        const mes = mesAtual.getMonth();
        
        // Nomes dos meses
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
                       'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
        
        // Nomes dos dias da semana
        const diasSemana = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
        
        // Primeiro dia do mês e total de dias
        const primeiroDia = new Date(ano, mes, 1);
        const diasNoMes = new Date(ano, mes + 1, 0).getDate();
        const primeiroDiaSemana = primeiroDia.getDay();
        
        // Dias do mês anterior
        const diasMesAnterior = new Date(ano, mes, 0).getDate();
        
        // Construir array de dias
        const dias = [];
        
        // Dias do mês anterior
        for (let i = primeiroDiaSemana - 1; i >= 0; i--) {
            dias.push({
                dia: diasMesAnterior - i,
                foraDoMes: true,
                data: new Date(ano, mes - 1, diasMesAnterior - i)
            });
        }
        
        // Dias do mês atual
        for (let i = 1; i <= diasNoMes; i++) {
            dias.push({
                dia: i,
                foraDoMes: false,
                data: new Date(ano, mes, i)
            });
        }
        
        // Dias do próximo mês (completar 42 dias = 6 semanas)
        const totalDiasCalendario = 42;
        const diasRestantes = totalDiasCalendario - dias.length;
        
        for (let i = 1; i <= diasRestantes; i++) {
            dias.push({
                dia: i,
                foraDoMes: true,
                data: new Date(ano, mes + 1, i)
            });
        }
        
        return (
            <div>
                {/* Cabeçalho com navegação */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '12px',
                    position: 'relative'
                }}>
                    <button 
                        onClick={() => setMesAtual(new Date(ano, mes - 1, 1))}
                        style={{
                            border: 'none',
                            background: 'none',
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: '#444',
                            padding: '0 12px',
                            borderRadius: '4px',
                            margin: '0 5px'
                        }}
                    >
                        &#8592;
                    </button>
                    
                    <select
                        value={mes}
                        onChange={(e) => setMesAtual(new Date(ano, parseInt(e.target.value), 1))}
                        style={{
                            fontWeight: 'bold',
                            fontSize: '16px',
                            padding: '4px 8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            marginRight: '10px'
                        }}
                    >
                        {meses.map((nomeMes, idx) => (
                            <option key={idx} value={idx}>
                                {nomeMes}
                            </option>
                        ))}
                    </select>
                    
                    <select
                        value={ano}
                        onChange={(e) => setMesAtual(new Date(parseInt(e.target.value), mes, 1))}
                        style={{
                            fontWeight: 'bold',
                            fontSize: '16px',
                            padding: '4px 8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            backgroundColor: 'white'
                        }}
                    >
                        {Array.from({ length: 31 }, (_, i) => 2020 + i).map(anoOpcao => (
                            <option key={anoOpcao} value={anoOpcao}>
                                {anoOpcao}
                            </option>
                        ))}
                    </select>
                    
                    <button 
                        onClick={() => setMesAtual(new Date(ano, mes + 1, 1))}
                        style={{
                            border: 'none',
                            background: 'none',
                            fontSize: '20px',
                            cursor: 'pointer',
                            color: '#444',
                            padding: '0 12px',
                            borderRadius: '4px',
                            margin: '0 5px'
                        }}
                    >
                        &#8594;
                    </button>
                </div>
                
                {/* Dias da semana */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '4px',
                    marginBottom: '8px'
                }}>
                    {diasSemana.map(dia => (
                        <div
                            key={dia}
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                padding: '6px 0',
                                color: '#444'
                            }}
                        >
                            {dia}
                        </div>
                    ))}
                </div>
                
                {/* Grid de dias */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gridTemplateRows: 'repeat(6, 1fr)',
                    gap: '4px'
                }}>
                    {dias.map((dia, index) => {
                        // Obter manutenções deste dia
                        const dataStr = `${dia.data.getFullYear()}-${(dia.data.getMonth() + 1).toString().padStart(2, '0')}-${dia.data.getDate().toString().padStart(2, '0')}`;
                        const manutencoesDoDiaAtual = manutencoesPorData[dataStr] || [];
                        const qtdManutencoes = manutencoesDoDiaAtual.length;
                        
                        // Verificar status
                        const now = new Date();
                        const nowSemHoras = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                        const diaSemHoras = new Date(dia.data.getFullYear(), dia.data.getMonth(), dia.data.getDate());
                        
                        let temAtrasado = false;
                        let temVencendo = false;
                        
                        if (diaSemHoras < nowSemHoras && !dia.foraDoMes && qtdManutencoes > 0) {
                            temAtrasado = true;
                        } else if (diaSemHoras >= nowSemHoras) {
                            const diffDays = Math.floor((diaSemHoras - nowSemHoras) / (1000 * 60 * 60 * 24));
                            if (diffDays <= 3 && qtdManutencoes > 0) {
                                temVencendo = true;
                            }
                        }
                        
                        return (
                            <div
                                key={`${dia.dia}-${index}`}
                                style={{
                                    height: '84px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    position: 'relative',
                                    backgroundColor: dia.foraDoMes ? '#f5f5f5' : '#fff',
                                    transition: 'all 0.2s ease',
                                    overflow: 'hidden',
                                    cursor: dia.foraDoMes ? 'default' : 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    if (!dia.foraDoMes) {
                                        e.currentTarget.querySelector('.overlay-calendario-manutencao')?.classList.add('visible');
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.querySelector('.overlay-calendario-manutencao')?.classList.remove('visible');
                                }}
                            >
                                <span style={{
                                    position: 'absolute',
                                    top: '4px',
                                    left: '6px',
                                    fontSize: '14px',
                                    fontWeight: 'normal',
                                    color: dia.foraDoMes ? '#aaa' : '#111'
                                }}>
                                    {dia.dia}
                                </span>
                                
                                {qtdManutencoes > 0 && !dia.foraDoMes && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '25px',
                                        left: '6px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        color: temAtrasado ? '#ff0000' : temVencendo ? '#ffaa00' : '#333',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        maxWidth: '90%'
                                    }}>
                                        <div style={{ marginBottom: '2px' }}>
                                            🔧 {qtdManutencoes} {qtdManutencoes === 1 ? 'manutenção' : 'manutenções'}
                                        </div>
                                        
                                        {/* Resumo das primeiras 2 manutenções */}
                                        {manutencoesDoDiaAtual.slice(0, 2).map((manutencao, idx) => {
                                            const clienteId = manutencao.Id_cliente || manutencao.id_cliente;
                                            return (
                                                <div key={idx} style={{
                                                    fontSize: '10px',
                                                    color: '#666',
                                                    marginBottom: '1px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '100%'
                                                }}>
                                                    Cliente #{clienteId}
                                                </div>
                                            );
                                        })}
                                        
                                        {qtdManutencoes > 2 && (
                                            <div style={{ fontSize: '10px', color: '#999', fontStyle: 'italic' }}>
                                                e mais {qtdManutencoes - 2}...
                                            </div>
                                        )}
                                        
                                        {temAtrasado && (
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '2px' }}>
                                                <span style={{ 
                                                    width: '8px', 
                                                    height: '8px', 
                                                    borderRadius: '50%', 
                                                    backgroundColor: '#ff0000',
                                                    marginRight: '4px'
                                                }} />
                                                <span style={{ fontSize: '11px', color: '#ff0000', fontWeight: 'bold' }}>Atrasado</span>
                                            </div>
                                        )}
                                        
                                        {!temAtrasado && temVencendo && (
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '2px' }}>
                                                <span style={{ 
                                                    width: '8px', 
                                                    height: '8px', 
                                                    borderRadius: '50%', 
                                                    backgroundColor: '#ffaa00',
                                                    marginRight: '4px'
                                                }} />
                                                <span style={{ fontSize: '11px', color: '#ffaa00', fontWeight: 'bold' }}>Vencendo</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                
                                {!dia.foraDoMes && (
                                    <div className="overlay-calendario-manutencao" style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 1,
                                        opacity: 0,
                                        pointerEvents: 'none',
                                        transition: 'opacity 0.2s ease'
                                    }}>
                                        <button 
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                selecionarDia(dia.data);
                                            }}
                                            style={{
                                                backgroundColor: 'rgb(235, 133, 0)',
                                                border: 'none',
                                                borderRadius: qtdManutencoes > 0 ? '5px' : '50%',
                                                color: 'white',
                                                padding: qtdManutencoes > 0 ? '6px 12px' : '0',
                                                width: qtdManutencoes > 0 ? 'auto' : '36px',
                                                height: qtdManutencoes > 0 ? 'auto' : '36px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: qtdManutencoes > 0 ? '12px' : '20px',
                                                fontWeight: 'bold',
                                                cursor: 'pointer',
                                                zIndex: 2,
                                                boxShadow: 'none',
                                                pointerEvents: 'auto'
                                            }}>
                                            {qtdManutencoes > 0 ? 'Ver todas' : '+'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className="container-geral fundo-branco">
            <MobileAddListener onOpen={() => { setModoEdicao(false); setDadosEdicao(null); setSelecionarProducaoAberto(true); }} />
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ margin: '0 0 15px 0', color: 'rgb(235, 133, 0)' }}>🔧 Manutenção</h2>
                <button 
                    onClick={() => {
                        setModoEdicao(false);
                        setDadosEdicao(null);
                        setSelecionarProducaoAberto(true);
                    }}
                    className="btn-adicionar"
                    style={{
                        backgroundColor: 'rgb(235, 133, 0)',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 600
                    }}
                >
                    Adicionar Manutenção
                </button>
            </div>

            {/* Campo de filtro */}
            <div className="filtro-container">
                <label className="filtro-label">Filtrar por:</label>
                <div className="filtro-input-container">
                    <div className="filtro-input-wrapper">
                        <input
                            type="text"
                            className="filtro-input"
                            placeholder={`Filtrar por ${
                                opcoesFiltro.find(op => op.value === tipoFiltro)?.label || tipoFiltro
                            }`}
                            value={filtro}
                            onChange={e => setFiltro(e.target.value)}
                        />
                        {filtro && (
                            <button
                                className="filtro-clear-button"
                                onClick={() => setFiltro('')}
                                title="Limpar filtro"
                            >
                                ×
                            </button>
                        )}
                    </div>

                    <div className="filtro-custom-select">
                        <button
                            className="filtro-custom-botao"
                            onClick={() => setDropdownAberto(!dropdownAberto)}
                        >
                            {opcoesFiltro.find(op => op.value === tipoFiltro)?.label || tipoFiltro}
                            <span className="seta-para-baixo">▼</span>
                        </button>
                        {dropdownAberto && (
                            <div className="filtro-custom-opcoes">
                                {opcoesFiltro.map(op => (
                                    <div
                                        key={op.value}
                                        onClick={() => {
                                            setTipoFiltro(op.value);
                                            setDropdownAberto(false);
                                        }}
                                    >
                                        {op.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Botão do Calendário */}
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '20px' }}>
                <button
                    onClick={abrirCalendario}
                    style={{
                        fontSize: '36px',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '10px',
                        transition: 'transform 0.2s',
                        filter: 'none'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                    }}
                    title="Ver calendário de manutenções"
                >
                    📅
                </button>
            </div>

            {/* Lista de Manutenções */}
            {loading ? (
                <div className="loading">⏳ Carregando manutenções...</div>
            ) : (
                <div className="lista-entregas">
                    <div className="entregas-header">
                        <span>Total de manutenções: {manutencoesFiltradas.length}</span>
                    </div>
                    {manutencoesFiltradas.length === 0 ? (
                        <div className="sem-entregas">
                            <p>🔧 Nenhuma manutenção encontrada</p>
                            <p>Clique em "+" para registrar a primeira manutenção</p>
                        </div>
                    ) : (
                        <div className="manutencao-cards-container">
                            {manutencoesFiltradas.map(manutencao => {
                                const manutencaoId = manutencao.id || manutencao.Id;

                                return (
                                    <div 
                                        key={manutencaoId} 
                                        className="manutencao-card"
                                    >
                                        <div className="manutencao-card-content">
                                            <div className="manutencao-card-header">
                                                Manutenção #{manutencaoId}
                                            </div>
                                            
                                            <div className="manutencao-card-fields">
                                                {/* Projeto */}
                                                {(manutencao.producoesId || manutencao.ProducoesId) && (
                                                    <div className="manutencao-field">
                                                        <span className="manutencao-field-label">Projeto:</span>{' '}
                                                        <span className="manutencao-field-value manutencao-field-link">
                                                            {getNomeProducao(manutencao.producoesId || manutencao.ProducoesId)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Cliente */}
                                                {(manutencao.id_cliente || manutencao.Id_cliente) && (
                                                    <div className="manutencao-field">
                                                        <span className="manutencao-field-label">Cliente:</span>{' '}
                                                        <span className="manutencao-field-value manutencao-field-success">
                                                            {getNomeCliente(manutencao.id_cliente || manutencao.Id_cliente)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Status da manutenção (verde; cancelada em vermelho) */}
                                                <div className="manutencao-field">
                                                    <span className="manutencao-field-label">Status:</span>{' '}
                                                    <span className="manutencao-field-value" style={{ fontWeight: 700, color: /cancel/i.test(manutencao.status || manutencao.Status || '') ? '#d93025' : '#1e8e3e' }}>
                                                        {manutencao.status || manutencao.Status || 'Pendente'}
                                                    </span>
                                                </div>

                                                {/* Responsável: o principal; sem principal e com vários, "N responsáveis" */}
                                                {(responsaveisPorManutencao[manutencaoId]?.length > 0 || manutencao.responsavel || manutencao.Responsavel) && (
                                                    <div className="manutencao-field">
                                                        <span className="manutencao-field-label">Responsável:</span>{' '}
                                                        <span className="manutencao-field-value">
                                                            {responsaveisPorManutencao[manutencaoId]?.length > 0
                                                                ? textoResponsavelCard(responsaveisPorManutencao[manutencaoId], r => r.pessoaNome ?? r.PessoaNome)
                                                                : (manutencao.responsavel || manutencao.Responsavel)}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Data Execução */}
                                                {(manutencao.dataExecucao || manutencao.DataExecucao) && (
                                                    <div className="manutencao-field">
                                                        <span className="manutencao-field-label">Data:</span>{' '}
                                                        <span className="manutencao-field-value">
                                                            {new Date(manutencao.dataExecucao || manutencao.DataExecucao).toLocaleDateString('pt-BR')}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Custo */}
                                                {(manutencao.custo || manutencao.Custo) && (
                                                    <div className="manutencao-field">
                                                        <span className="manutencao-field-label">Custo:</span>{' '}
                                                        <span className="manutencao-field-value manutencao-field-price">
                                                            R$ {parseFloat(manutencao.custo || manutencao.Custo).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Descrição */}
                                                {(manutencao.descricao || manutencao.Descricao) && (
                                                    <div className="manutencao-field manutencao-field-full">
                                                        <span className="manutencao-field-label">Descrição:</span>{' '}
                                                        <span className="manutencao-field-value">
                                                            {manutencao.descricao || manutencao.Descricao}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Pessoa */}
                                            {manutencao.pessoa && (
                                                <div className="manutencao-pessoa-info">
                                                    <span style={{ fontWeight: '600', color: '#666' }}>Pessoa:</span>{' '}
                                                    {manutencao.pessoa.nomePessoa || manutencao.pessoa.NomePessoa}
                                                </div>
                                            )}
                                        </div>

                                        <div className="manutencao-card-actions">
                                            <button 
                                                className="btn-editar-manutencao"
                                                onClick={() => fetchManutencaoPorId(manutencaoId)}
                                            >
                                                Editar
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            )}

            {/* Modal de Nova/Editar Manutenção */}
            {novaManutencaoAberta && (
                <div className="modal-overlay" style={{ zIndex: 95000 }} onClick={() => {
                    setNovaManutencaoAberta(false);
                    setModoEdicao(false);
                    setDadosEdicao(null);
                    setDataPreSelecionadaManutencao('');
                }}>
                    <div 
                        className="modal-content" 
                        onClick={e => e.stopPropagation()} 
                        style={{ 
                            maxWidth: 900, 
                            minWidth: 600, 
                            width: '90vw', 
                            padding: 32, 
                            borderRadius: 16,
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}
                    >
                        <div className="modal-header">
                            <h3>{modoEdicao ? 'Editar Manutenção' : 'Nova Manutenção'}</h3>
                            <button 
                                className="modal-close"
                                onClick={() => {
                                    setNovaManutencaoAberta(false);
                                    setModoEdicao(false);
                                    setDadosEdicao(null);
                                    setDataPreSelecionadaManutencao('');
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <FormularioManutencao
                            onSubmit={handleSubmitManutencao}
                            onCancel={() => {
                                setNovaManutencaoAberta(false);
                                setModoEdicao(false);
                                setDadosEdicao(null);
                                setProducaoSelecionada(null);
                                setDataPreSelecionadaManutencao('');
                            }}
                            responsaveis={pessoas}
                            producaoSelecionada={producaoSelecionada}
                            modoEdicao={modoEdicao}
                            dadosEdicao={dadosEdicao}
                            dataPreSelecionada={dataPreSelecionadaManutencao}
                            onCriarResponsavel={async ({ nome, custoHora }) => {
                                if (!nome || !nome.trim()) return;
                                try {
                                    await apiCall(BASE_URLS_PESSOAS, '', 'POST', {
                                        id: 0,
                                        nome,
                                        custoHora: custoHora ? parseFloat(custoHora) : 0
                                    });
                                    await fetchPessoas();
                                } catch (err) {
                                    throw err;
                                }
                            }}
                            onPessoaCriada={fetchPessoas}
                            responsaveisManutencao={responsaveisManutencao}
                            onAdicionarResponsavel={() => setAdicionarRespAberto(true)}
                            onRemoverResponsavel={handleRemoverResponsavel}
                            onDefinirPrincipal={handleDefinirPrincipal}
                            refFormularioMateriaPrima={refFormularioMateriaPrima}
                        />
                    </div>
                </div>
            )}

            {/* Modal do Calendário */}
            {calendarioAberto && (
                <>
                    <style>{`
                        .overlay-calendario-manutencao.visible {
                            opacity: 1 !important;
                            pointer-events: auto !important;
                        }
                    `}</style>
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 95000
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            padding: '20px',
                            maxWidth: '900px',
                            width: '90%',
                            maxHeight: '85vh',
                            overflow: 'auto',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                            position: 'relative'
                        }}>
                            <button
                                onClick={() => setCalendarioAberto(false)}
                                style={{
                                    position: 'absolute',
                                    top: '15px',
                                    right: '15px',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '28px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    fontWeight: 700,
                                    width: '35px',
                                    height: '35px',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s',
                                    padding: 0
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#f0f0f0';
                                    e.currentTarget.style.color = 'rgb(235, 133, 0)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                    e.currentTarget.style.color = '#666';
                                }}
                            >
                                ×
                            </button>

                            <h2 style={{ marginTop: 0, marginBottom: '20px', color: 'rgb(235, 133, 0)', textAlign: 'center', fontSize: '20px' }}>
                                🔧 Calendário de Manutenções
                            </h2>

                            {renderCalendario()}

                            <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center', fontSize: '12px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#f44336' }}></div>
                                        <span>Atrasado</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#ffa726' }}></div>
                                        <span>Vencendo (até 3 dias)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* Modal de Manutenções do Dia */}
            {mostrarManutencoesoDia && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 95010
                }} onClick={() => setMostrarManutencoesoDia(false)}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        padding: '20px',
                        maxWidth: '950px',
                        width: '90%',
                        maxHeight: '80vh',
                        overflow: 'auto',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        position: 'relative'
                    }} onClick={(e) => e.stopPropagation()}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px',
                            padding: '10px 0',
                            borderBottom: '1px solid #eee'
                        }}>
                            <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: '0', color: 'rgb(235, 133, 0)' }}>
                                🔧 Manutenções - {datasSelecionadas && datasSelecionadas.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' })}
                            </h2>

                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <button
                                    onClick={() => {
                                        if (!datasSelecionadas) return;
                                        const dataStr = `${datasSelecionadas.getFullYear()}-${(datasSelecionadas.getMonth() + 1).toString().padStart(2, '0')}-${datasSelecionadas.getDate().toString().padStart(2, '0')}`;
                                        abrirNovaManutencaoParaData(dataStr);
                                    }}
                                    style={{
                                        backgroundColor: 'rgb(235, 133, 0)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    + Nova Manutenção
                                </button>
                                <button 
                                    onClick={() => setMostrarManutencoesoDia(false)}
                                    style={{
                                        border: 'none',
                                        background: 'none',
                                        fontSize: '24px',
                                        cursor: 'pointer',
                                        color: '#444',
                                        padding: '0 15px'
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                        </div>

                        <div className="lista-clientes">
                            {manutencoesDoDia.length === 0 && (
                                <div style={{
                                    textAlign: 'center',
                                    padding: '30px',
                                    color: '#888'
                                }}>
                                    Nenhuma manutenção para esta data.
                                </div>
                            )}
                            
                            {manutencoesDoDia.map(manutencao => {
                                const manutencaoId = manutencao.Id || manutencao.id;
                                const clienteId = manutencao.Id_cliente || manutencao.id_cliente;
                                const dataExecucao = manutencao.DataExecucao || manutencao.dataExecucao;
                                const descricao = manutencao.Descricao || manutencao.descricao || '';
                                const responsavel = manutencao.Responsavel || manutencao.responsavel || 'Não definido';
                                
                                let hora = 'N/D';
                                if (dataExecucao) {
                                    const partesDataHora = dataExecucao.replace('T', ' ').split(' ');
                                    if (partesDataHora.length > 1) {
                                        hora = partesDataHora[1].substring(0, 5);
                                    }
                                }

                                return (
                                    <div 
                                        key={manutencaoId}
                                        style={{ 
                                            display: 'flex', 
                                            borderBottom: '1px solid #ddd', 
                                            padding: '10px 0',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f9f9f9';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <div style={{ 
                                            width: '80%', 
                                            display: 'flex', 
                                            flexDirection: 'row', 
                                            gap: '20px', 
                                            padding: '10px 0' 
                                        }}>
                                            {/* Coluna ID */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '60px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>ID</label>
                                                <span>{manutencaoId}</span>
                                            </div>
                                            
                                            {/* Coluna ID Cliente */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '80px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>ID Cliente</label>
                                                <span>{clienteId || 'N/A'}</span>
                                            </div>
                                            
                                            {/* Coluna Hora */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '80px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Hora</label>
                                                <span>{hora}</span>
                                            </div>
                                            
                                            {/* Coluna Responsável */}
                                            <div style={{ display: 'flex', flexDirection: 'column', minWidth: '120px' }}>
                                                <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Responsável</label>
                                                <span>{responsavel}</span>
                                            </div>
                                            
                                            {/* Coluna Descrição */}
                                            {descricao && (
                                                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Descrição</label>
                                                    <span style={{ 
                                                        overflow: 'hidden', 
                                                        textOverflow: 'ellipsis', 
                                                        whiteSpace: 'nowrap' 
                                                    }}>
                                                        {descricao.length > 30 ? `${descricao.substring(0, 30)}...` : descricao}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        
                                        <div style={{ 
                                            width: '20%', 
                                            display: 'flex', 
                                            justifyContent: 'flex-end', 
                                            alignItems: 'center' 
                                        }}>
                                            <button
                                                onClick={() => editarManutencaoDoDia(manutencao)}
                                                style={{
                                                    backgroundColor: 'rgb(235, 133, 0)',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    padding: '8px 15px',
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                    fontSize: '14px',
                                                    transition: 'background-color 0.2s'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'rgb(208, 116, 0)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'rgb(235, 133, 0)';
                                                }}
                                            >
                                                Editar
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Seleção de Projeto */}
            {selecionarProducaoAberto && (
                <div className="modal-overlay" onClick={() => setSelecionarProducaoAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95020 }}>
                    <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '95%', maxWidth: 1000, background: '#fff', borderRadius: 12, padding: 20, maxHeight: '90vh', overflowY: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Selecione um Projeto</h3>
                            <button onClick={() => setSelecionarProducaoAberto(false)} aria-label="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
                        </div>

                        {/* Filtro de Projeto */}
                        <div style={{ marginBottom: 16, display: 'flex', gap: 10, alignItems: 'center' }}>
                            <input
                                type="text"
                                placeholder={`Filtrar por ${
                                    tipoFiltroProducao === 'todos' ? 'todos os campos' :
                                    tipoFiltroProducao === 'producaoId' ? 'ID Projeto' :
                                    tipoFiltroProducao === 'contratoId' ? 'Contrato ID' :
                                    tipoFiltroProducao === 'oportunidadeId' ? 'Oportunidade ID' :
                                    tipoFiltroProducao === 'titulo' ? 'Título' :
                                    tipoFiltroProducao === 'clienteId' ? 'Cliente ID' :
                                    tipoFiltroProducao === 'vendaId' ? 'Venda ID' : ''
                                }...`}
                                value={filtroProducao}
                                onChange={(e) => setFiltroProducao(e.target.value)}
                                style={{ flex: 1, padding: '10px', borderRadius: 6, border: '1px solid #ddd', fontSize: 14 }}
                            />
                            <select
                                value={tipoFiltroProducao}
                                onChange={(e) => setTipoFiltroProducao(e.target.value)}
                                style={{ 
                                    padding: '10px 16px', 
                                    borderRadius: 6, 
                                    border: '1px solid #ddd', 
                                    fontSize: 14, 
                                    backgroundColor: 'rgb(235, 133, 0)', 
                                    color: 'white', 
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    minWidth: 150
                                }}
                            >
                                <option value="todos">Filtrar por: Todos</option>
                                <option value="producaoId">ID Projeto</option>
                                <option value="contratoId">Contrato ID</option>
                                <option value="oportunidadeId">Oportunidade ID</option>
                                <option value="titulo">Título</option>
                                <option value="clienteId">Cliente ID</option>
                                <option value="vendaId">Venda ID</option>
                            </select>
                        </div>

                        {loadingProducoes ? (
                            <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>Carregando projetos...</div>
                        ) : producoesFinalizadas.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>Nenhum projeto finalizado dentro da garantia encontrado.<br /><span style={{ fontSize: 13 }}>Garantia e manutenção só podem ser abertas para projetos finalizados, dentro do prazo de garantia.</span></div>
                        ) : (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
                                {producoesFinalizadas.map((producao, idx) => {
                                    const producaoId = producao.producaoId || producao.ProducaoId;
                                    const contratoId = producao.contratosId || producao.ContratosId;
                                    const oportunidadeId = producao.oportunidadeId || producao.OportunidadeId;
                                    const titulo = producao.oportunidadeTitulo || producao.OportunidadeTitulo || 'Sem título';
                                    const status = producao.status || producao.Status || 'N/A';
                                    const clienteId = producao.clienteId || producao.ClienteId;
                                    const vendaId = producao.vendaId || producao.VendaId;

                                    return (
                                        <div
                                            key={producaoId || idx}
                                            onClick={() => selecionarProducao(producao)}
                                            style={{
                                                padding: 16,
                                                border: '2px solid #e0e0e0',
                                                borderRadius: 8,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                backgroundColor: '#fafafa'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = 'rgb(235, 133, 0)';
                                                e.currentTarget.style.backgroundColor = '#fff8f0';
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = '#e0e0e0';
                                                e.currentTarget.style.backgroundColor = '#fafafa';
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <span style={{ fontSize: 12, fontWeight: 700, color: 'rgb(235, 133, 0)' }}>ID: {producaoId}</span>
                                                    <span style={{ 
                                                        fontSize: 11, 
                                                        padding: '2px 8px', 
                                                        borderRadius: 10, 
                                                        backgroundColor: status === 'Concluído' ? '#e6f4ea' : status === 'Em Andamento' ? '#e3f2fd' : '#fff8e1',
                                                        color: status === 'Concluído' ? '#1e8e3e' : status === 'Em Andamento' ? '#1565c0' : '#f9a825',
                                                        fontWeight: 600
                                                    }}>
                                                        {status}
                                                    </span>
                                                </div>
                                                <div style={{ fontSize: 14, fontWeight: 600, color: '#333' }}>{titulo}</div>
                                                <div style={{ fontSize: 12, color: '#666', display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                    {contratoId && <span>Contrato: {contratoId}</span>}
                                                    {oportunidadeId && <span>Oportunidade: {oportunidadeId}</span>}
                                                    {clienteId && <span>Cliente: {clienteId}</span>}
                                                    {vendaId && <span>Venda: {vendaId}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Modal Adicionar Responsável */}
            {/* Concluir manutenção: horas reais de cada responsável */}
            {conclusaoPendente && (
                <PopupHorasReais
                    titulo="Concluir manutenção: horas reais dos responsáveis"
                    responsaveis={responsaveisManutencao.map(r => ({
                        id: r.id || r.responsaveisId || r.ResponsaveisId,
                        nome: r.nome || r.Nome,
                        horasPrevistas: r.horasPrevistas ?? r.HorasPrevistas,
                        horasReais: r.horasReais ?? r.HorasReais
                    }))}
                    onCancelar={() => setConclusaoPendente(null)}
                    onConfirmar={(horas) => {
                        const dados = conclusaoPendente;
                        horasReaisConclusaoRef.current = horas;
                        setConclusaoPendente(null);
                        setTimeout(() => handleSubmitManutencao(dados), 0);
                    }}
                />
            )}
            {novaPessoaAberta && (
                <PopupNovaPessoa
                    onFechar={() => setNovaPessoaAberta(false)}
                    onCriada={async (criada) => {
                        await fetchPessoas();
                        const id = criada?.id ?? criada?.Id;
                        if (id) setNovoResponsavel(prev => ({ ...prev, responsavelId: String(id) }));
                    }}
                />
            )}

            {adicionarRespAberto && (
                <div className="modal-overlay" onClick={() => setAdicionarRespAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95030 }}>
                    <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: '92%', maxWidth: 500, background: '#fff', borderRadius: 12, padding: 20 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                            <h3 style={{ margin: 0, color: 'rgb(235, 133, 0)' }}>Adicionar Responsável</h3>
                            <button onClick={() => setAdicionarRespAberto(false)} aria-label="Fechar" title="Fechar" style={{ backgroundColor: 'rgb(235, 133, 0)', color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, cursor: 'pointer' }}>×</button>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label style={{ fontSize: 13, marginBottom: 6, fontWeight: 600 }}>Responsável *</label>
                                <select
                                    value={novoResponsavel.responsavelId}
                                    onChange={(e) => setNovoResponsavel({ ...novoResponsavel, responsavelId: e.target.value })}
                                    style={{ padding: '10px', borderRadius: 6, border: '1px solid #ddd' }}
                                >
                                    <option value="">Selecione um responsável</option>
                                    {pessoas.map((p, idx) => (
                                        <option key={p.id || p.Id || idx} value={p.id || p.Id}>
                                            {p.nome || p.Nome}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap', marginTop: 12 }}>
                            <div style={{ width: '120px', minWidth: '100px' }}>
                                <label style={{ fontSize: 12, marginBottom: 4, fontWeight: 600, display: 'block' }}>Previstas</label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={novoResponsavel.horasPrevistas}
                                    onChange={(e) => setNovoResponsavel({ ...novoResponsavel, horasPrevistas: e.target.value })}
                                    style={{ width: '100%', padding: '6px 8px', borderRadius: 6, border: '1px solid #ccc', fontSize: 12, boxSizing: 'border-box' }}
                                    placeholder="0.00"
                                    title="As horas reais são lançadas ao concluir a manutenção"
                                />
                            </div>
                            <button
                                type="button"
                                onClick={() => setNovaPessoaAberta(true)}
                                style={{ padding: '8px 14px', backgroundColor: '#fff', color: 'rgb(235, 133, 0)', border: '1px solid rgb(235, 133, 0)', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
                            >
                                Adicionar nova pessoa
                            </button>
                            <div style={{ flex: 1, minWidth: 0 }} />
                        </div>
                        </div>

                        <div style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'center' }}>
                            <button
                                onClick={handleAdicionarResponsavel}
                                style={{ padding: '12px 30px', backgroundColor: 'rgb(235, 133, 0)', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                            >
                                Adicionar
                            </button>
                            <button
                                onClick={() => setAdicionarRespAberto(false)}
                                style={{ padding: '12px 30px', backgroundColor: '#ccc', color: '#333', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <LoadingOverlay isLoading={loading} message="Processando..." />
        </div>
    );

}

export default ManutencaoDropdown;
